/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {FeatureStateDependencies} from './feature-state-dependencies';

export type AdnRouterHelperApi = {
  services: FeatureStateDependencies;
  createModelComms: () => any;
  createRouterHelper: (
    states: string,
    resourceProvider: any,
    parent: string,
    dir: string,
    listTemplate?: string | null
  ) => any;
  createRouterAndChildHelper: (
    states: string,
    resourceProvider: any,
    childProvider: any,
    parent: string,
    dir: string,
    listTemplate?: string | null
  ) => any;
};

export function collectState(name: string | Ng2StateDeclaration, cfg?: any): Ng2StateDeclaration {
  if (typeof name === 'string') {
    return {name, ...cfg};
  }
  return name;
}

export function collectStatesFromProvider(
  register: (provider: { state: (name: string, cfg?: any) => any }, adnRouterHelperProvider: { $get: () => AdnRouterHelperApi }) => void,
  adnRouterHelper: AdnRouterHelperApi
): Ng2StateDeclaration[] {
  const states: Ng2StateDeclaration[] = [];
  const $stateProvider = {
    state: (name: string, cfg?: any) => {
      states.push(collectState(name, cfg));
      return $stateProvider;
    }
  };
  register($stateProvider, {$get: () => adnRouterHelper});
  return states;
}
